//export class TemperatureConverter {
//	static toCelsius(temperature: number): number {
//		return ((temperature) * (5 / 9));
//	}
//}